import { fork, takeLatest } from 'redux-saga/effects';

import {
    authenticateUser,
    deserialiseIntercomAppId,
    deserialiseIntercomSettings,
    reconnectIntercom,
    setupIntercom,
    updateIntercomOfPageChange
} from './IntercomHelper';
import { BOOTSTRAP_INTERCOM, SETUP_INTERCOM } from './IwIntercom.actions';
import { CHANGE_ROUTER } from '../iwRouter/IwRouter.actions';

export const intercomSagaWorkers = [
    fork(SetupIntercomWorker),
    fork(BootIntercomWorker)
];

function* SetupIntercomWorker() {
    yield takeLatest(SETUP_INTERCOM, function* (action) {
        const appID = deserialiseIntercomAppId(action.siteContext);
        const intercomSettings = deserialiseIntercomSettings(
            action.siteContext
        );

        if (typeof window.Intercom === 'function') {
            yield reconnectIntercom(appID, intercomSettings);
        } else {
            yield setupIntercom(appID, intercomSettings);
        }
    });
}

function* BootIntercomWorker() {
    yield takeLatest(BOOTSTRAP_INTERCOM, function* (action) {
        const appID = deserialiseIntercomAppId(action.siteContext);
        const intercomSettings = deserialiseIntercomSettings(
            action.siteContext
        );

        yield authenticateUser(appID, intercomSettings);
        yield fork(ChangeURLWorker);
    });
}

function* ChangeURLWorker() {
    yield takeLatest(CHANGE_ROUTER, function* () {
        yield updateIntercomOfPageChange();
    });
}
